/* eslint-disable max-lines */

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import * as React from 'react';
import { useEffect } from 'react';
import { MentionNode } from './MentionNode';

type HookProps = {
  createdCallback: (name: string, email: string, val: string) => void;
  destroyedCallback: (value: string) => void;
};

const HandleModifyMentionsPlugin: React.FC<HookProps> = ({
  createdCallback,
  destroyedCallback,
}): JSX.Element | null => {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      editor.registerMutationListener(
        MentionNode,

        (mutatedNodes, { prevEditorState }) => {
          mutatedNodes.forEach((n, k) => {
            switch (n) {
              case 'created': {
                const node = editor.getEditorState()._nodeMap.get(k) as MentionNode;
                if (node) {
                  createdCallback(node.__mention, node.__email, node.__value);
                }
                break;
              }
              case 'destroyed': {
                const node = prevEditorState._nodeMap.get(k) as MentionNode;
                if (node) {
                  destroyedCallback(node.__value);
                }
                break;
              }
              default: {
                break;
              }
            }
          });
        }
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [editor]
  );

  return null;
};

export default HandleModifyMentionsPlugin;
